var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVsCodeLink)?_c('span',{class:_vm.$style.link,on:{"click":_vm.onClickVsCodeLink}},[_vm._t("default")],2):_c('a',{attrs:{"href":_vm.href,"target":_vm.target || '_blank'},on:{"click":_vm.onClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }